import React , {useContext} from 'react';
import CardStyled from 'components/Card.jsx';
import { TagBox, TagButton } from 'etiquette';
import { SurveyContext } from "providers/survey";
import useI8n from "i18n/useI18n";

const ExperiencePromoted = ({ handleProgress }) => {

  const { translate } = useI8n();
  const { setSurvey } = useContext(SurveyContext);

  const handleBox = (value) => {
    setSurvey('experience_promoted',value)
    handleProgress("experience_promoted", 1, false, true);
  }

  return (
    <CardStyled>
      <TagBox
        text={translate("WHICH_EXPERIENCE_PROMOTED")}
        subtext=''
        titleAlign='center'
      >
        <TagButton
          text={translate("EXP_PROMO_TUESDAY")}
          onClick={() => handleBox("martesLocal")}
          name="experience"
          label="experience1"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_WEDNESDAY")}
          onClick={() => handleBox("miercolesAutor")}
          name="experience"
          label="experience2"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_CATERING")}
          onClick={() => handleBox("catering")}
          name="experience"
          label="experience3"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_CHEFS_TABLE")}
          onClick={() => handleBox("chefsTable")}
          name="experience"
          label="experience4"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_BRUNCH")}
          onClick={() => handleBox("brunch")}
          name="experience"
          label="experience5"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_EVENTS")}
          onClick={() => handleBox("events")}
          name="experience"
          label="experience6"
          margin='0 16px 20px 0'
        />
        <TagButton
          text={translate("EXP_PROMO_NONE")}
          onClick={() => handleBox("none")}
          name="experience"
          label="experience7"
          margin='0 16px 20px 0'
        />
      </TagBox>
    </CardStyled>
  );
}; 

export default ExperiencePromoted;

/*
Miércoles de Autor
•⁠  ⁠Catering
•⁠  ⁠Chef’s Table
•⁠  ⁠Brunch
•⁠  ⁠Eventos
•⁠  ⁠⁠Ninguna*/